export const GET_LOOKUP_REQUEST = "GET_LOOKUP_REQUEST";
export const GET_LOOKUP_SUCCESS = "GET_LOOKUP_SUCCESS";
export const GET_LOOKUP_FAIL = "GET_LOOKUP_FAIL";